import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function PanoramaWideAngleSelectIcon(props: IconProps) {
    return <Icon {...props} iconKey={"panorama_wide_angle_select"}/>
}
